/* eslint-disable react-native/no-inline-styles */
import {Icon, Layout, Text} from '@ui-kitten/components';
import React from 'react';
import {StyleSheet, TouchableOpacity, View} from 'react-native';
import Colors from '../../constants/Colors';
import {px} from '../../utils';

const TitleRow = ({
  title,
  iconName,
  accessoryRight,
  leftIconName,
  onIconClick,
  onLeftIconClick,
  iconColor = '#fff',
  leftIconColor = '#fff',
  containerStyle,
  textStyle = {},
  type = 'secondary',
}) => {
  const isPrimary = type === 'primary';
  const isSecondary = type === 'secondary';

  return (
    <Layout
      style={[
        styles.container,
        isPrimary && styles.primaryContainer,
        isSecondary && styles.secondaryContainer,
        containerStyle,
      ]}>
      <View style={{flexDirection: 'row'}}>
        {Boolean(leftIconName) && (
          <TouchableOpacity onPress={onLeftIconClick}>
            <Icon
              style={styles.icon}
              fill={leftIconColor}
              name={leftIconName}
            />
          </TouchableOpacity>
        )}
        <Text
          style={[
            isPrimary && styles.primaryTitleText,
            isSecondary && styles.secondaryTitleText,
            textStyle,
          ]}>
          {title}
        </Text>
      </View>
      {Boolean(iconName && !accessoryRight) && (
        <TouchableOpacity onPress={onIconClick}>
          <Icon style={styles.icon} fill={iconColor} name={iconName} />
        </TouchableOpacity>
      )}
      {Boolean(accessoryRight && !iconName) && accessoryRight}
    </Layout>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingHorizontal: px(17),
  },
  primaryContainer: {
    paddingTop: px(15),
    paddingBottom: px(15),
    height: px(60),
    backgroundColor: Colors.primaryColor,
  },
  secondaryContainer: {
    height: px(40),
  },
  icon: {
    width: px(35),
    height: px(35),
  },
  primaryTitleText: {
    color: 'white',
    fontSize: px(18),
    lineHeight: px(30),
  },
  secondaryTitleText: {
    fontSize: px(16),
    lineHeight: px(20),
  },
});

export default TitleRow;
